import { ArrayInput, Edit, FormTab, SelectInput, SimpleFormIterator, TabbedForm, TextInput } from 'react-admin';
import { CustomTitle } from '../../components/CustomTitle';
import { ParserAlgo } from '../sessions/SpeakerInput/types';

// const ToolbarP = (props: unknown) => (
//   <Toolbar {...props} >
//     <SaveButton />
//     <DeleteButton label='Reset (not undoable)' />
//   </Toolbar>
// );

export const SettingsEdit = (props: unknown) => (
  <Edit {...props} title={<CustomTitle />}>
    <TabbedForm /*toolbar={<ToolbarP />} */>
      <FormTab label="Speakers AutoParser">
        <SelectInput
          fullWidth
          source="speakersAutoParser_algo"
          choices={[
            { id: ParserAlgo.LASTNAME, name: 'APELLIDO en mayusculas (PEREZ juan)' },
            { id: ParserAlgo.lastName, name: 'apellido nombres (perez juan carlos)' },
            { id: ParserAlgo.namesLastn, name: 'nombres apellido (juan carlos perez)' },
            { id: ParserAlgo.nameLastn, name: 'nombre apellidos (juan perez gonzalez)' },
          ]}
        />
        <TextInput fullWidth source="speakersAutoParser_speakerSeparator" label="Separador (separa 2 personas')" />
        <TextInput fullWidth source="speakersAutoParser_nameSeparator" label="Separador (separa nombre(s) de apellido(s)')" />
        <ArrayInput source="speakersAutoParser_remover" label="Palabras para ingorar (regular expression)">
          <SimpleFormIterator disableReordering>
            <TextInput source="word" label="" />
          </SimpleFormIterator>
        </ArrayInput>
      </FormTab>
    </TabbedForm>
  </Edit>
);
